import { Row, Col, Drawer, Modal, message } from "antd";
import { HomeOutlined, RedoOutlined, AppstoreOutlined, FileTextOutlined, CalendarOutlined, ShoppingOutlined, CodeSandboxOutlined } from "@ant-design/icons";
import { Scrollbars } from "react-custom-scrollbars";
import { useHistory } from "react-router-dom";
import { processSync } from "../../../Sync/syncData";
import useSyncProgressStore from "../../../../stores/useSyncProgressStore";
import usePOSConfigStore from "../../../../stores/usePOSConfigStore";
import printController from "../../../../lib/printer/printController";
import openDrawer from "../../../../lib/printer/openDrawer";
import salesReportPrinter from "../../../../lib/printer/salesReportPrinter";
import salesReportCWHCPrinter from "../../../../lib/printer/saleReportCWHCPrinter";
import { getWorkflowData } from "../../../../utils/getWorkflowData";
import db from "../../../../database";
import dayjs from "dayjs";
import messages from "../../../../errors/messages.en-IN.json";
import useSessionStore from "../../../../stores/useSessionStore";
import useAuthStore from "../../../../stores/useAuthStore";
import useTransactionStore from "../../../../stores/useTransactionStore";

import POSLogo from "../../../../assets/images/NewLogoCW.svg";
import Close from "../../../../assets/images/close-x.svg";
import unlinkTillIcon from "../../../../assets/images/unlink-icon.svg";
import couponIcon from "../../../../assets/images/coupon-icon.svg";
import printerIcon from "../../../../assets/images/printerIcon.svg";
import salesReportIcon from "../../../../assets/images/salesReportIcon.svg";
import openDrawerIcon from "../../../../assets/images/openDrawer.svg";
import layAwaySvg from "../../../../assets/images/layaway.svg";
import Discard from "../../../../assets/images/return.png";
import SyncSide from "../../../../assets/images/sideFullSync.svg";
import userIcon from "../../../../assets/images/userId.svg";
import productionIcon from "../../../../assets/images/production.svg";
import wallet from "../../../../assets/images/wallet.svg";
import Logout from "../../../../assets/images/logout-new.svg";
import discountIcon from "../../../../assets/images/discount.svg";
import Offers from "../../../../assets/images/promoTag.svg";
import SyncIcon from "../../../../assets/images/syncIcon.svg";
import Retrieve from "../../../../assets/images/retrieve.png";
import useCartStore from "../../../../stores/useCartStore";

const version_number = import.meta.env.VITE_APP_VERSION || "0.0.0";

const menuItemStyle = {
  display: "flex",
  alignItems: "center",
  cursor: "pointer",
  marginBottom: "2vh",
};

const menuLabelStyle = {
  fontFamily: "Inter",
  fontWeight: 500,
  fontSize: "1.2em",
  paddingLeft: "1vw",
  color: "#0F0718",
};

const menuIconStyle = { height: "2.5vh" };
const menuIconStyleDark = { height: "2.5vh", filter: "brightness(0)" };

const SideMenuDrawer = ({
  tillLink,
  setTillLink,
  setActiveInput,
  searchInputRef,
  tillData,
  posConfig,
  cart,
  setCart,
  tillUnlink,
  enableProduction,
  setCouponModalVisible,
  setCouponInput,
  dispatchEvent,
  reconstructedObject,
  CWHardwareController,
  setShowPaymentMethods,
  processOrder,
  upsertPOSLog,
  isReturnDisabled,
  shouldShowReturnButton,
  setFilterDrawer,
  setShowReturnOptions,
  setIsBlindReceiptPending,
  setReasonPopup,
  handleCartTotalClick,
  isOnline,
  errorMessage,
  setSyncLoad,
  selectedSaleTypeData,
  parkedList,
  handleKeyvalue,
  setIsparkedBill,
  setManualDiscountModalVisible,
  setDisplayUAECustomerSearch,
  handleProductionClick,
  renderCustomerWallet,
  logoutLoading,
  handleLogout,
  setOffersDrawerOpen,
  deleteReceipt,
  cartObj,
  matchedSaleType,
  fetchWalletData,
  handleLoyaltyPayment,
  posConfigData,
  domainURL,
  removeCutomer,
  setIsNriBilling,
  setIsPanCustomer,
  hasShownCustomerModalRef,
}) => {
  const history = useHistory();
  const { resetProgress } = useSyncProgressStore();

  return (
    <Drawer
      placement="left"
      width="20%"
      closable={false}
      title={
        <div style={{ display: "flex", alignItems: "center" }}>
          <img src={POSLogo} style={{ height: "2vw" }} />
          <img
            src={Close}
            onClick={() => {
              (setTillLink(false), setActiveInput("search"));
              if (searchInputRef?.current) {
                searchInputRef?.current.focus();
              }
            }}
            style={{
              marginLeft: "auto",
              paddingTop: "2vh",
              cursor: "pointer",
              width: "1.5vw",
            }}
          />
        </div>
      }
      headerStyle={{ background: "#F3F4F9", borderBottom: "none" }}
      styles={{
        body: {
          background: "#F3F4F9",
          paddingTop: 0,
          borderRadius: "none",
        },
      }}
      open={tillLink}
      onClose={() => {
        (setTillLink(false), setActiveInput("search"));
        if (searchInputRef?.current) {
          searchInputRef?.current.focus();
        }
      }}
    >
      <Row gutter={[16, 16]} style={{ fontSize: "1vw" }}>
        <Col span={24}>
          <Scrollbars style={{ height: "80vh" }}>
            <Row>
              <Col span={1} />
              <Col
                onClick={() => {
                  setTillLink(false);
                  history.push("/");
                }}
                style={menuItemStyle}
                span={22}
              >
                <HomeOutlined style={{ fontSize: "2.2vh", color: "#0F0718" }} />
                <span style={menuLabelStyle}>Home</span>
              </Col>
              <Col span={1} />
              <Col
                span={1}
                style={{
                  display: tillData.tillAccess.unlinkTill === "Y" ? "block" : "none",
                }}
              />
              <Col
                onClick={tillUnlink}
                style={{
                  ...menuItemStyle,
                  display: tillData.tillAccess.unlinkTill === "Y" ? "flex" : "none",
                }}
                span={22}
              >
                <img src={unlinkTillIcon} style={menuIconStyle} alt="" />
                <span style={menuLabelStyle}>Unlink Till</span>
              </Col>
              <Col
                span={1}
                style={{
                  display: tillData.tillAccess.unlinkTill === "Y" ? "block" : "none",
                }}
              />
              {enableProduction ? (
                <Row>
                  {" "}
                  <Col span={1} />
                  <Col
                    onClick={() => {
                      window.location.reload();
                    }}
                    style={menuItemStyle}
                    span={22}
                  >
                    <RedoOutlined style={{ fontSize: "2.2vh", color: "#0F0718" }} />
                    <span style={menuLabelStyle}>Refresh</span>
                  </Col>
                </Row>
              ) : (
                <>
                  <Col span={1} />
                  <Col
                    style={menuItemStyle}
                    span={22}
                    onClick={() => {
                      if (cart.items.length > 0 && cart.isReturn !== true) {
                        setCouponModalVisible(true);
                        setTillLink(false);
                        setCouponInput("");
                      } else {
                        // Actionable modal instead of toast so cashier explicitly
                        // acknowledges WHY the coupon can't be applied.
                        const isEmpty = !(cart.items && cart.items.length > 0);
                        Modal.info({
                          title: "Coupon Not Applicable",
                          content: isEmpty ? messages.errors.coupons.empty_cart : messages.errors.coupons.coupon_not_applied,
                          okText: "OK",
                          centered: true,
                        });
                      }
                    }}
                  >
                    <img src={couponIcon} style={menuIconStyle} alt="" />
                    <span style={menuLabelStyle}>Coupon Code</span>
                  </Col>
                  <Col span={1} />
                  <Col span={1} />
                  <Col
                    onClick={async () => {
                      if (cart.items.length > 0) {
                        const { workflowRules, approvers } = await getWorkflowData();
                        // Check if workflowRules exist
                        if (workflowRules && workflowRules.length > 0) {
                          // If workflowRules exist, iterate over them
                          workflowRules.forEach((res) => {
                            if (res.eventName === "Print Draft bill") {
                              setTillLink(false);
                              dispatchEvent(res.eventName, res.ruleName, res.ruleCondition, approvers, null, (eventData) => {
                                if (eventData?.approvalGranted) {
                                  let updatedCart = { ...cart, orderTime: dayjs(new Date()).format("DD-MM-YYYY HH:mm:ss"), draftFlag: true };
                                  printController(updatedCart);
                                }
                              });
                            }
                          });
                        } else {
                          // If workflowRules do not exist, execute some other logic
                          let updatedCart = { ...cart, orderTime: dayjs(new Date()).format("DD-MM-YYYY HH:mm:ss"), draftFlag: false };
                          printController(updatedCart);
                        }
                      }
                    }}
                    style={{
                      ...menuItemStyle,
                      cursor: cart.items.length > 0 && reconstructedObject?.DraftPrint === "Y" ? "pointer" : "not-allowed",
                    }}
                    span={22}
                  >
                    <img src={printerIcon} style={{ height: "2.9vh" }} alt="" />
                    <span style={menuLabelStyle}>Print</span>
                  </Col>
                  <Col span={1} />
                  <Col
                    span={1}
                    style={{
                      display: tillData?.tillAccess?.layAway === "Y" && selectedSaleTypeData?.cwrSaletype?.enableLayaway === "Y" ? "block" : "none",
                    }}
                  />
                  <Col
                    onClick={() => {
                      if (cart.items.length > 0 && cart?.isReturn !== true) {
                        // BUG-1570: For a retrieved layaway, cart.paid carries the previously
                        // collected advance (cart.paid === cart.advancePayment, payments: []), so the
                        // old `cart.paid === 0` check let a second "Layaway" click fall straight into
                        // processOrder("layaway") — re-processing the order with no fresh payment.
                        // Gate on the payment actually taken THIS session instead: new payments push
                        // into cart.payments and bump cart.paid by their amount on top of advancePayment
                        // (see usePaymentFlow updatedPaid = paid + advancePayment), so paid - advance is
                        // the fresh amount. Equals 0 for a fresh empty cart and for a retrieved layaway
                        // with no new payment; > 0 only once money is actually taken.
                        const freshPayment = parseFloat(cart.paid || 0) - parseFloat(cart.advancePayment || 0);
                        if (freshPayment <= 0) {
                          if (posConfig?.allowLayawaywithoutPayment === "Y") {
                            upsertPOSLog(cart, "LAY");
                            const updatedCart = JSON.parse(JSON.stringify(cart));
                            updatedCart.layAway = "Y";
                            updatedCart.statusType = "layAway";
                            setCart(updatedCart);
                            setShowPaymentMethods(true);
                            setTillLink(false);
                            processOrder("layaway");
                          } else {
                            message.warning("Minimum payment required to create Layaway order");
                          }
                        } else if (posConfig?.allowLayawaywithoutPayment !== "Y") {
                          upsertPOSLog(cart, "LAY");
                          const updatedCart = JSON.parse(JSON.stringify(cart));
                          updatedCart.layAway = "Y";
                          updatedCart.statusType = "layAway";
                          setCart(updatedCart);
                          setTillLink(false);
                          processOrder("layaway");
                        }
                      } else if (cart.items.length === 0) {
                      } else {
                        message.error("Layaway isn't supported for returns. Please choose a different option.");
                      }
                    }}
                    style={{
                      ...menuItemStyle,
                      cursor: cart.items.length > 0 ? "pointer" : "not-allowed",
                      display: tillData?.tillAccess?.layAway === "Y" ? "flex" : "none",
                    }}
                    span={22}
                  >
                    <img src={layAwaySvg} style={menuIconStyle} alt="" />
                    <span style={menuLabelStyle}>Layaway</span>
                  </Col>
                  <Col
                    span={1}
                    style={{
                      display: posConfig?.enableReceiptlessReturn === "Y" ? "block" : "none",
                    }}
                  />
                  <Col
                    onClick={() => {
                      if (isReturnDisabled) return;

                      const posConfigLS = usePOSConfigStore.getState().posConfig;
                      const walletEnabled = posConfigLS?.enableReceiptlessReturn2 === "Y";

                      // WALLET FLOW
                      if (walletEnabled) {
                        if (cart.isReturn === true) return;

                        if (cart.payments.length > 0) {
                          message.error("Payments already added. Cannot process return.");
                          return;
                        }

                        setTillLink(false);
                        if (posConfig?.allowReturnRefund === "Y" || posConfig?.allowReturnCreditNote === "Y" || posConfig?.allowReturnExchange === "Y") {
                          // BUG-1213: Defer cart.isReturn until user confirms in ReturnOptionsModal.
                          // Setting isReturn prematurely causes stale state after browser refresh.
                          setIsBlindReceiptPending(true);
                          setShowReturnOptions(true);
                        } else {
                          // No return options — apply immediately since user has no choice to cancel
                          const updatedCart = {
                            ...cart,
                            isReturn: true,
                            isBlindReceipt: true,
                          };
                          setCart(updatedCart);
                          useCartStore.getState().setCart(updatedCart);
                          useTransactionStore.getState().setSelectedReturnType("REFUND");
                          setFilterDrawer(true);
                        }
                        return;
                      }

                      if (cart.isReturn !== true && cart.items.length > 0 && cart.payments.length === 0) {
                        Modal.confirm({
                          title: "You are about to process a return without a receipt. Would you like to proceed?",
                          icon: null,
                          cancelText: "No",
                          okText: "Yes",
                          autoFocusButton: null,
                          okButtonProps: { style: { display: "inline-block" } },
                          onOk: async () => {
                            setTillLink(false);
                            let updatedCart = { ...cart };

                            updatedCart.total = -updatedCart.total;
                            updatedCart.tax = -updatedCart.tax;
                            updatedCart.isReturn = true;
                            updatedCart.isBlindReceipt = true;
                            updatedCart.totalQty = -updatedCart.totalQty;

                            updatedCart.items = updatedCart.items.map((item) => {
                              let grossUnit = (Math.abs(item.sunitprice) - Math.abs(item.discount)) / Math.abs(item.weight);
                              let newItem = { ...item };

                              newItem.nettotal = -item.nettotal;
                              newItem.weight = -item.weight;
                              newItem.isReturn = true;
                              newItem.sunitprice = -item.sunitprice;
                              newItem.netList = -item.nettotal;
                              newItem.linetax = Math.abs(newItem.nettotal) > 0 ? -parseFloat(item.taxAmount.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision)) : 0;
                              newItem.linenet =
                                Math.abs(newItem.nettotal) > 0 ? -parseFloat((item.nettotal - item.taxAmount).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision)) : 0;
                              newItem.linegross = Math.abs(newItem.nettotal) > 0 ? parseFloat(item.nettotal.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision)) : 0;
                              newItem.netStd = -item.netStd;
                              newItem.listPrice = Math.abs(newItem.nettotal) > 0 ? -item.listPrice : 0;
                              newItem.grossunit =
                                Math.abs(newItem.nettotal) > 0
                                  ? item.isReturn
                                    ? -parseFloat(grossUnit.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision))
                                    : parseFloat(grossUnit.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision))
                                  : 0;
                              newItem.taxAmount = -item.taxAmount;
                              return newItem;
                            });

                            await setCart(updatedCart);
                            if (posConfig?.showReason === "Y" || posConfig?.showReferenceNo === "Y" || posConfig?.showRemarks === "Y") {
                              setReasonPopup(true);
                            } else {
                              await handleCartTotalClick();
                            }
                          },
                        });
                      }
                    }}
                    style={{
                      ...menuItemStyle,
                      cursor: isReturnDisabled ? "not-allowed" : "pointer",
                      display: shouldShowReturnButton ? "flex" : "none",
                    }}
                    span={22}
                  >
                    <img src={Discard} style={{ height: "2.7vh" }} alt="" />
                    <span style={menuLabelStyle}>Return this Receipt</span>
                  </Col>
                  <Col
                    span={1}
                    style={{
                      display: posConfig?.enableReceiptlessReturn === "Y" ? "block" : "none",
                    }}
                  />
                  <Col
                    span={1}
                    style={{
                      display: posConfig?.enableFullSync === "Y" ? "block" : "none",
                    }}
                  />
                  <Col
                    span={22}
                    onClick={async () => {
                      if (!isOnline) {
                        errorMessage("Sync Failed", "Please check your network connection and try again");
                        return;
                      }

                      setTillLink(false);

                      if (cart.items.length > 0) {
                        message.error("To perform a Full Sync, please clear the cart items!");
                        return;
                      }

                      // Start Full Sync only if cart is empty
                      useSessionStore.getState().setLastUpdatedTime(null);
                      setSyncLoad(true);

                      const tillData = useAuthStore.getState().tillData;
                      const defaultCustomer = selectedSaleTypeData?.customer?.b2cCustomerId ? selectedSaleTypeData.customer : tillData?.tillAccess?.csBunit?.b2cCustomer;

                      setCart((prevCart) => ({
                        ...prevCart,
                        customer: defaultCustomer,
                      }));

                      await processSync(tillData, "Full Sync");
                      window.location.reload();
                    }}
                    style={{
                      ...menuItemStyle,
                      display: posConfig?.enableFullSync === "Y" ? "flex" : "none",
                    }}
                  >
                    <img src={SyncSide} style={{ height: "2vh" }} alt="" />
                    <span style={menuLabelStyle}>Full Sync</span>
                  </Col>
                  <Col
                    span={1}
                    style={{
                      display: posConfig?.enableFullSync === "Y" ? "block" : "none",
                    }}
                  />
                  <Col
                    span={1}
                    style={{
                      display: tillData?.tillAccess?.salesReport === "Y" ? "block" : "none",
                    }}
                  />
                  <Col
                    onClick={async () => {
                      let ordersData = await db.ordersData.toArray();
                      ordersData = ordersData.filter((data) => data.tillStatus === "open");
                      if (CWHardwareController) {
                        salesReportCWHCPrinter(ordersData);
                      } else {
                        salesReportPrinter(ordersData);
                      }
                    }}
                    style={{
                      ...menuItemStyle,
                      display: tillData?.tillAccess?.salesReport === "Y" ? "flex" : "none",
                    }}
                    span={22}
                  >
                    <img src={salesReportIcon} style={menuIconStyle} alt="" />
                    <span style={menuLabelStyle}>Sales Report</span>
                  </Col>
                  <Col
                    span={1}
                    style={{
                      display: tillData?.tillAccess?.salesReport === "Y" ? "block" : "none",
                    }}
                  />
                  <Col span={1} />
                  <Col
                    onClick={() => {
                      openDrawer();
                    }}
                    style={menuItemStyle}
                    span={22}
                  >
                    <img src={openDrawerIcon} style={menuIconStyle} alt="" />
                    <span style={menuLabelStyle}>Open Drawer</span>
                  </Col>
                  <Col span={1} />
                  {posConfig?.showOffers === "Y" && (
                    <>
                      <Col span={1} />
                      <Col
                        onClick={() => {
                          setTillLink(false); // CLOSE LEFT DRAWER
                          setOffersDrawerOpen(true); // OPEN OFFERS DRAWER
                        }}
                        style={menuItemStyle}
                        span={22}
                      >
                        <img src={Offers} style={menuIconStyle} alt="" />
                        <span style={menuLabelStyle}>Offers</span>
                      </Col>
                      <Col span={1} />
                    </>
                  )}

                  <Col span={1} />
                  <Col
                    onClick={() => posConfig?.dataSyncDashboard === "Y" && tillData.tillAccess.dataSyncMonitor === "Y" && history.push("/dashboard2")}
                    style={{
                      ...menuItemStyle,
                      cursor: posConfig?.dataSyncDashboard === "Y" && tillData.tillAccess.dataSyncMonitor === "Y" ? "pointer" : "not-allowed",
                    }}
                    span={22}
                  >
                    <img src={SyncIcon} style={menuIconStyleDark} alt="" />
                    <span style={menuLabelStyle}>Data Sync Monitor</span>
                  </Col>
                  <Col span={1} />

                  <Col
                    span={1}
                    style={{
                      display: tillData?.tillAccess?.manualDiscount === "Y" ? "block" : "none",
                    }}
                  />
                  <Col
                    onClick={() => {
                      if (parseInt(cart.total) > 0) {
                        setTillLink(false);
                        setManualDiscountModalVisible(true);
                      }
                    }}
                    style={{
                      ...menuItemStyle,
                      display: tillData?.tillAccess?.manualDiscount === "Y" ? "flex" : "none",
                    }}
                    span={22}
                  >
                    <img src={discountIcon} style={menuIconStyleDark} alt="" />
                    <span style={menuLabelStyle}>Discount</span>
                  </Col>
                  <Col
                    span={1}
                    style={{
                      display: tillData?.tillAccess?.manualDiscount === "Y" ? "block" : "none",
                    }}
                  />

                  {posConfig?.enableUAECustomer === "Y" && <Col span={1} />}
                  {posConfig?.enableUAECustomer === "Y" && (
                    <Col
                      onClick={() => {
                        setDisplayUAECustomerSearch(true);
                      }}
                      style={menuItemStyle}
                      span={22}
                    >
                      <img src={userIcon} style={menuIconStyle} alt="" />
                      <span style={menuLabelStyle}>UAE Customer</span>
                    </Col>
                  )}
                  {posConfig?.enableUAECustomer === "Y" && <Col span={1} />}
                  {posConfig?.enableProduction === "Y" && <Col span={1} />}
                  {posConfig?.enableProduction === "Y" && (
                    <Col onClick={handleProductionClick} style={menuItemStyle} span={22}>
                      <img src={productionIcon} style={{ ...menuIconStyle, marginBottom: "0.2rem" }} alt="" />
                      <span style={menuLabelStyle}>Production Order</span>
                    </Col>
                  )}

                  {posConfig?.enableStockIndent === "Y" && (
                    <Col onClick={() => history.push("/inventory/stock-indent")} style={menuItemStyle} span={22}>
                      <CodeSandboxOutlined style={{ fontSize: "2.2vh", color: "#0F0718" }} />
                      <span style={menuLabelStyle}>Stock Indent</span>
                    </Col>
                  )}

                  {posConfig?.enablePurchase === "Y" && (
                    <Col onClick={() => history.push("/purchaseOrder")} style={menuItemStyle} span={22}>
                      <ShoppingOutlined style={{ fontSize: "2.2vh", color: "#0F0718" }} />
                      <span style={menuLabelStyle}>Purchase Order</span>
                    </Col>
                  )}
                  <Col span={1} />
                  {posConfig?.enableAggregator === "Y" && (
                    <Col
                      style={menuItemStyle}
                      span={22}
                      onClick={() => {
                        history.push("/aggregator");
                      }}
                    >
                      <AppstoreOutlined style={{ fontSize: "2.2vh", color: "#0F0718" }} />
                      <span style={menuLabelStyle}>Aggregator</span>
                    </Col>
                  )}
                  {posConfig?.enableEstimate === "Y" && (
                    <Col
                      onClick={() => {
                        deleteReceipt(true);
                        history.push("/estimate");
                      }}
                      style={menuItemStyle}
                      span={22}
                    >
                      <FileTextOutlined style={{ fontSize: "2.2vh", color: "#0F0718" }} />
                      <span style={menuLabelStyle}>Estimate</span>
                    </Col>
                  )}
                  {posConfig?.enablePreOrder === "Y" && (
                    <Col
                      onClick={() => {
                        deleteReceipt(true);
                        history.push("/preorder");
                      }}
                      style={menuItemStyle}
                      span={22}
                    >
                      <CalendarOutlined style={{ fontSize: "2.2vh", color: "#0F0718" }} />
                      <span style={menuLabelStyle}>Pre-Order</span>
                    </Col>
                  )}
                  {renderCustomerWallet()}
                  <Col span={1} />
                  <Col
                    onClick={() => {
                      window.location.reload();
                    }}
                    style={menuItemStyle}
                    span={22}
                  >
                    <RedoOutlined style={{ fontSize: "2.2vh", color: "#0F0718" }} />
                    <span style={menuLabelStyle}>Refresh</span>
                  </Col>
                </>
              )}
            </Row>
          </Scrollbars>
        </Col>
        <Col
          span={24}
          style={{
            width: "80%",
            borderTop: "1px solid #929098",
            position: "absolute",
            bottom: "2.5vh",
            padding: "1vh 1vw",
          }}
        >
          <Row>
            <Col span={1} />

            <Col style={{ ...menuItemStyle, cursor: logoutLoading ? "not-allowed" : "pointer", paddingTop: "1vh", marginBottom: 0 }} onClick={handleLogout} span={20}>
              <img src={Logout} alt="" />
              <span style={menuLabelStyle}>{logoutLoading ? `Logging out...` : `Logout`}</span>
            </Col>
            <Col span={24} style={{ position: "absolute", bottom: "5vh", right: "0" }}>
              <p style={{ color: "#0f071840", textAlign: "right", paddingRight: "1vw", fontSize: "0.6rem", fontWeight: 400 }}>v{version_number}</p>
            </Col>
          </Row>
        </Col>
      </Row>
    </Drawer>
  );
};

export default SideMenuDrawer;
